// extracted by mini-css-extract-plugin
export default {"container":"container---Uxdhk","header":"header---sXzbw","body":"body---pd4y0"};